<div class="tw-flex tw-items-center tw-justify-center tw-h-screen tw-px-5">
  @if (showPaymentVerificationLoader) {
    <div class="tw-flex tw-flex-col tw-items-center tw-max-w-md">
      <div class="icon-circle icon-circle--muted tw-mb-6">
        <img src="/assets/images/hourglass_fill.svg" alt="Loading" height="48" width="48" />
      </div>
      <h2 class="subtitle">{{ 'saferPayment.verifyingPayment' | translate }}</h2>
    </div>
  } @else {
    @if (paymentSuccess) {
      <div class="tw-flex tw-flex-col tw-items-center tw-max-w-md">
        <div class="icon-circle icon-circle--success tw-mb-6">
          <calio-lucide-icon name="check" [size]="48" [strokeWidth]="2" class="tw-text-green-600" />
        </div>
        <h2 class="subtitle">{{ 'saferPayment.successTitle' | translate }}</h2>
        <p class="main-text tw-mt-3">{{ 'saferPayment.securityNote' | translate }}</p>
      </div>
    } @else if (paymentNotFound) {
      <div class="tw-flex tw-flex-col tw-items-center tw-max-w-md">
        <div class="icon-circle icon-circle--warning tw-mb-6">
          <calio-lucide-icon name="alert-triangle" [size]="48" [strokeWidth]="1.5" class="tw-text-amber-500" />
        </div>
        <h2 class="subtitle">{{ 'saferPayment.paymentNotFoundTitle' | translate }}</h2>
        <p class="main-text tw-mt-3">{{ 'saferPayment.paymentNotFoundNote' | translate }}</p>
      </div>
    } @else {
      <div class="tw-flex tw-flex-col tw-items-center tw-max-w-md">
        <div class="icon-circle icon-circle--error tw-mb-6">
          <calio-lucide-icon name="close" [size]="48" [strokeWidth]="2" class="tw-text-destructive" />
        </div>
        <h2 class="subtitle">{{ paymentFailedMessage || ('saferPayment.failedTitle' | translate) }}</h2>
        <p class="main-text tw-mt-3">
          {{ 'saferPayment.failedNote2' | translate }}
          <br /><br />
          {{ 'saferPayment.failedNote1' | translate }}
        </p>
      </div>
    }
  }
</div>
